// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CapabilitySetCapability } from './capability-set-capability';
import {
    CapabilitySetCapabilityFromJSON,
    CapabilitySetCapabilityFromJSONTyped,
    CapabilitySetCapabilityToJSON,
    CapabilitySetCapabilityToJSONTyped,
} from './capability-set-capability';

/**
 * 
 * @export
 * @interface CapabilitySet
 */
export interface CapabilitySet {
    /**
     * 
     * @type {string}
     * @memberof CapabilitySet
     */
    audience: CapabilitySetAudienceEnum;
    /**
     * 
     * @type {Array<CapabilitySetCapability>}
     * @memberof CapabilitySet
     */
    capabilities: Array<CapabilitySetCapability>;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySet
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySet
     */
    display_name: string;
    /**
     * Whether the caller's deployment allows editing this set in the app (admin-owned and editing turned on).
     * @type {boolean}
     * @memberof CapabilitySet
     */
    editable: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CapabilitySet
     */
    groups: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySet
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySet
     */
    scope: CapabilitySetScopeEnum;
    /**
     * Which authority owns the set: the deployment manifest or an admin.
     * @type {string}
     * @memberof CapabilitySet
     */
    source: CapabilitySetSourceEnum;
}


/**
 * @export
 */
export const CapabilitySetAudienceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type CapabilitySetAudienceEnum = typeof CapabilitySetAudienceEnum[keyof typeof CapabilitySetAudienceEnum];

/**
 * @export
 */
export const CapabilitySetScopeEnum = {
    Resource: 'resource',
    Tenant: 'tenant'
} as const;
export type CapabilitySetScopeEnum = typeof CapabilitySetScopeEnum[keyof typeof CapabilitySetScopeEnum];

/**
 * @export
 */
export const CapabilitySetSourceEnum = {
    Manifest: 'manifest',
    Admin: 'admin'
} as const;
export type CapabilitySetSourceEnum = typeof CapabilitySetSourceEnum[keyof typeof CapabilitySetSourceEnum];


/**
 * Check if a given object implements the CapabilitySet interface.
 */
export function instanceOfCapabilitySet(value: object): value is CapabilitySet {
    if (!('audience' in value) || value['audience'] === undefined) return false;
    if (!('capabilities' in value) || value['capabilities'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('editable' in value) || value['editable'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function CapabilitySetFromJSON(json: any): CapabilitySet {
    return CapabilitySetFromJSONTyped(json, false);
}

export function CapabilitySetFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapabilitySet {
    if (json == null) {
        return json;
    }
    return {
        
        'audience': json['audience'],
        'capabilities': ((json['capabilities'] as Array<any>).map(CapabilitySetCapabilityFromJSON)),
        'description': json['description'],
        'display_name': json['display_name'],
        'editable': json['editable'],
        'groups': json['groups'],
        'name': json['name'],
        'scope': json['scope'],
        'source': json['source'],
    };
}

export function CapabilitySetToJSON(json: any): CapabilitySet {
    return CapabilitySetToJSONTyped(json, false);
}

export function CapabilitySetToJSONTyped(value?: CapabilitySet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'audience': value['audience'],
        'capabilities': ((value['capabilities'] as Array<any>).map(CapabilitySetCapabilityToJSON)),
        'description': value['description'],
        'display_name': value['display_name'],
        'editable': value['editable'],
        'groups': value['groups'],
        'name': value['name'],
        'scope': value['scope'],
        'source': value['source'],
    };
}
